/*
  The grade filter (D18, §7.3).

  It was dead: SetView held its value in a useState of its own and SetViewTable
  destructured `filterGrade` and never read it. It is wired now, against the predicate
  that already existed — filterCardsGraded in constants/grades.ts, which implements
  "non-zero population at this grade" against the exact strings this control emits.

  Two changes beyond dropping MUI's FormControl / InputLabel / Select / MenuItem for the
  shared Select (§7.4, task 6a):

    - it is CONTROLLED. Its own useState was a second copy of a value SetView also held;
      with the filter live, two copies is one that can be stale, and SetView needs to
      clear it when the set changes.
    - the empty option is a real, selectable option, not Select's `placeholder` (which
      renders a DISABLED first option). §7.3 requires that choosing the empty option
      clears the filter, so the visitor has to be able to get back to it.
*/

import Select from 'components/Select';

import { GRADE_FILTER_OPTIONS } from 'constants/grades';

export interface FilterGradeDDLProps {
  /* "" is no filter. Otherwise a grade string from constants/grades. */
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/* Named rather than "None": it says what choosing it does, not what it is not. */
const ALL_GRADES = { value: '', label: 'All grades' };

const FilterGradeDDL = (props: FilterGradeDDLProps) => {
  const { value, onChange, className = '' } = props;

  return (
    <Select
      label="Grade"
      value={value}
      options={[ALL_GRADES, ...GRADE_FILTER_OPTIONS]}
      onChange={onChange}
      className={className}
    />
  );
};

export default FilterGradeDDL;
